import { Batch, TemplateType } from '@e-origin/shared';

import { BatchHVStatusIndicator } from './BatchHVStatusIndicator';
import { BatchLVStatusIndicator } from './BatchLVStatusIndicator';

interface BatchStatusIndicatorProps {
  batch: Batch;
}

export const BatchStatusIndicator: React.FC<BatchStatusIndicatorProps> = ({ batch }) => {
  if (!batch) {
    return null;
  }

  return batch.templateType === TemplateType.HIGH_VALUE_H1 ? <BatchHVStatusIndicator batch={batch} /> : <BatchLVStatusIndicator batch={batch} />;
};
